module.exports = __webpack_public_path__ + "static/img/hangye5.b872a36a.svg";